import { createActions } from 'redux-actions';

const INITIALIZE_KEYBOARD_EVENTS =
  'DESIGN_PRO/KEYBOARD_EVENTS/INITIALIZE_KEYBOARD_EVENTS';

const actions = createActions({
  [INITIALIZE_KEYBOARD_EVENTS]: () => null,
});

export default {
  actions: actions.designPro.keyboardEvents,
};
